<template>
  <el-form
    :model="xqDetail"
    ref="xqDetail"
    :rules="rules"
    label-width="100px"
    :hide-required-asterisk="false"
  >
    <el-form-item label="详细描述" v-show="this.xqDetail.detail">
      <div id="wangEditor"></div>
    </el-form-item>
    <el-form-item label="解决方案" v-show="this.xqDetail.jjfa">
      <div id="wangEditor2"></div>
    </el-form-item>
    <el-row>
      <el-col :span="8">
        <el-form-item label="问题分类">
          <el-input v-model="xqDetail.sortName" disabled></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="期望完成时间">
          <el-input v-model="xqDetail.finishTime" disabled></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="计划工时">
          <el-input v-model="xqDetail.planTime" disabled>
            <template slot="append">人日</template>
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item label="附件">
      <el-table
        :data="xqDetail.file"
        fit
        highlight-current-row
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
        size="mini"
      >
        <el-table-column
          label="上传人"
          align="left"
          prop="xm"
          min-width="80px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="上传时间"
          align="left"
          prop="uploadtime"
          min-width="150px"
          :show-overflow-tooltip="true"
        />

        <el-table-column
          label="文件名称"
          align="left"
          prop="filename"
          min-width="250px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <el-link @click="openPreview(scope.row)" type="primary">
              {{ scope.row.filename }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column
          label="大小"
          align="left"
          prop="filesize"
          min-width="100px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="操作"
          align="left"
          min-width="100px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="handleDownloadFile(scope.row)"
              >下载</el-button
            >
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
      </el-table>
    </el-form-item>
    <el-form-item label="评审人" prop="reviewer" key="8">
      <treeselect
        v-model="reviewer"
        multiple
        placeholder="请选择员工"
        :options="deptUser"
        :disable-branch-nodes="true"
        :show-count="true"
        value-consists-of="LEAF_PRIORITY"
        no-results-text="未搜到任何结果"
        :clear-on-select="true"
        :normalizer="normalizer"
        style="width: 100%"
        size="small"
        @select="handleChangeYg"
      />
    </el-form-item>
    <el-row class="suButton">
      <el-button @click="hideDialog()">取消</el-button>
      <el-button type="primary" @click="submitForm()">保存并发起</el-button>
    </el-row>
  </el-form>
</template>
<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { formatMomentDate, sizeFormat } from "@/utils/utils";
import moment from "moment";
import "moment/locale/zh-cn";
import { mapGetters } from "vuex";
import wangEditor from "wangeditor";

import { getQuestionDetail, startReview } from "@/api/question.js";
export default {
  components: { Treeselect },
  computed: {
    ...mapGetters(["deptUser", "task"]),
  },
  props: ["mxParams"],
  data() {
    return {
      normalizer(node) {
        return {
          children: node.users,
        };
      },
      form: {
        rldxActive: 1,
      },

      reviewer: [],
      rules: {
        reviewer: [
          { required: true, message: "评审人不能为空", trigger: "blur" },
        ],
      },
      xqDetail: {
        title: null,
        status: null,
        sort: null,
        questionLevel: null,
        line: null,
        xmbh: null,
        productVersion: null,
        module: null,
        influenceVersion: null,
        designee: null,
        content: null,
        finishTime: "",
        planTime: null,
        detail: null,
        jjfa: null,
        fileIds: null,
        designeeName: null,
        pinglun: [],
      },
    };
  },
  created() {
    if (!this.deptUser || this.deptUser.length == 0) {
      this.$store.dispatch("common/getDeptUser");
    }

    this.getData();
  },
  mounted() {
    let editor = new wangEditor(`#wangEditor`);
    let editor2 = new wangEditor(`#wangEditor2`);

    editor = this.editorConfig(editor);
    editor2 = this.editorConfig(editor2);

    // 创建编辑器
    this.editor = editor;
    this.editor2 = editor2;
  },
  methods: {
    hideDialog() {
      this.$emit("hideDialog");
    },
    getData() {
      getQuestionDetail({ id: this.mxParams.id }).then((res) => {
        if (res.code == 0) {
          if (res.data.file) {
            res.data.file.forEach((item) => {
              item.filesize = sizeFormat(item.filesize);
            });
          }
          this.xqDetail = res.data;
          this.editor.txt.html(this.xqDetail.detail);
          this.editor2.txt.html(this.xqDetail.jjfa);
          this.editor.disable();
          this.editor2.disable();
        }
      });
    },
    editorConfig(editor, height) {
      editor.config.placeholder = "请输入内容";
      editor.config.height = height ? height : 200;
      editor.config.uploadImgMaxSize = 10 * 1024 * 1024; //图片大小10M
      editor.config.uploadImgMaxLength = 1;
      editor.config.uploadFileName = "file"; //上传参数 自定义
      editor.config.uploadImgTimeout = 60000; //60s
      editor.config.uploadImgServer = window.g.apiUrl + "/system/uploadPicFile";
      editor.config.uploadImgHeaders = {
        "x-token": localStorage.getItem("token"), // 设置请求头
      };
      editor.config.uploadImgHooks = {
        //监听
        timeout: function (xhr, editor) {
          this.$message.error("上传图片超时！");
        },
        customInsert: function (insertImg, result, editor) {
          if (result.code == 0) {
            var url = result.msg;
            insertImg(url);
          }
        },
      };
      editor.config.excludeMenus = ["video", "link", "code"];
      // 配置 onchange 回调函数，将数据同步到 vue 中
      // editor.config.onchange = function () {
      //   if (editor.txt.html() == "") {
      //     editor.txt.html("&nbsp");
      //   }
      // };

      editor.create();
      return editor;
    },
    openPreview(row) {
      const url = row.url;
      window.open(url);
    },
    handleDownloadFile(row) {
      const filePath = row.absolutepath;
      const fileName = row.filename;
      const url =
        window.g.apiUrl +
        "system/downloadFile?fileName=" +
        fileName +
        "&filePath=" +
        filePath;
      // 组装a标签
      const elink = document.createElement("a");
      // 设置下载文件名
      elink.download = fileName;
      elink.style.display = "none";
      elink.href = url;
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },

    handleChangeYg(e) {
      this.xqDetail.designeeName = e.xm;
    },
    submitForm() {
      if (this.reviewer.length === 0) {
        this.$message.error("请选择评审人！");
        return;
      }
      // const params = {
      //   id: this.mxParams.id,
      //   reviewer,
      //   mc: this.mxParams.title
      // };
      startReview(
        this.mxParams.id,
        this.reviewer.toString(),
        this.mxParams.title
      ).then((res) => {
        if (res.code == 0) {
          this.$message.success("保存成功!");
          this.$emit("hideDialog");
          this.$emit("getList");
        } else {
          this.$message.error(success.msg);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.suButton {
  text-align: right;
  margin-top: 10px;
}
.star {
  position: absolute;
  top: 13px;
  color: #f56c6c;
  left: 40px;
}
.r {
  margin: 0 10px;
  .r_title {
    text-align: center;
    line-height: 40px;
    border-bottom: 2px solid #e4e7ed;
    box-sizing: border-box;
    height: 40px;
    margin-bottom: 15px;
  }
}
.zpsm-comment-item {
  margin-top: 15px;
  .top {
    display: flex;
    line-height: 30px;
    font-weight: bold;
    font-size: 15px;
    > div {
      margin-right: 15px;
    }
    > div:nth-of-type(1) {
      background-color: #8080ff;
      color: #fff;
      height: 30px;
      line-height: 30px;
      width: 30px;
      text-align: center;
      border-radius: 50%;
    }
  }
  .middle {
    line-height: 20px;
    color: #555;
    padding-left: 45px;
    margin: 10px 0;
  }
  .bottom {
    font-size: 12px;
    padding-left: 45px;
    color: #7f7f7f;
  }
}
</style>